import FLAG from 'config/flag.singleton';
import DND from 'constants/dnd.const';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import nullBind from 'utils/functions/nullBind.util';
import logger from 'utils/logger.util';
import randomString from 'utils/values/randomString.util';

const L = logger('dnd');

const USE_SPAM_LOG = fromAnyToBool(FLAG.loggerSpam);
const USE_NONCE = fromAnyToBool(FLAG.dndNonce);
const USE_CHECK_DUPLICATES = false;

const ID_MAP = {};

const dnd = (type, data) => {
  try {
    const result = JSON.stringify({ ...data, type, $nonce: USE_NONCE ? randomString.short() : void 1 });

    if (USE_CHECK_DUPLICATES) {
      ID_MAP[result] = 1 + (ID_MAP[result] ?? 0);
      if (ID_MAP[result] > 1) L.error('()', 'duplicates count:', ID_MAP[result], type, ':', data, '->', result);
    }

    if (USE_SPAM_LOG) L.trace('()', type, ':', data, '->', result);

    return result;
  } catch (e) {
    L.error('()', e);
    return '';
  }
};

for (const [name, type] of Object.entries(DND)) {
  dnd[name] = nullBind(dnd, type);
}

// noinspection JSUnusedGlobalSymbols
export default dnd;
